module.exports = __webpack_public_path__ + "static/media/desktop-product-shot-ksac.a3369528.png";